import { css } from '@emotion/css'
import { Color, RgbColor } from 'utils/variables'
import { minScreen } from 'utils/mediaQueries'

export const wrap = css`
  border: solid 1px rgba(${RgbColor.LightBlack}, 0.2);
  border-radius: 10px;
  ${minScreen('md')} {
  }
`;

export const item = css`
  &:not(:last-child) {
    border-bottom: solid 1px rgba(${RgbColor.LightBlack}, 0.2);
  }
`;

export const input = css`
  display: none;
  :checked + label::before {
    opacity: 1;
  }
`;

export const label = css`
  padding: 10px 20px 10px 45px;
  position: relative;
  display: flex;
  &::before {
    width: 8px;
    height: 15px;
    position: absolute;
    top: 50%;
    left: 17px;
    border-bottom: solid 2px ${Color.PaleGreen};
    border-right: solid 2px ${Color.PaleGreen};
    content: '';
    display: block;
    opacity: 0;
    transform: translate(0, -62%) rotate(45deg);
  }
`;